import React, { useEffect } from "react";
import "./Layout.css";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";
import { useLocation, useParams } from "react-router-dom";
import HeroSvg from "./HeroSvg.jsx";
import FooterMenu from "../Footer/FooterMenu";

const Layout = ({ children }) => {
	const { pathname } = useLocation();

	const ScrollToTop = () => {
		const { pathname } = useLocation();

		useEffect(() => {
			window.scrollTo(0, 0);
			// eslint-disable-next-line
		}, [pathname]);

		return null;
	};
	
	ScrollToTop();

	const normalizedPathname = pathname.replace(/\/+$/, "");

	return (
		<React.Fragment>
			<div className="home-page-background pb-lg-0 pb-md-0">
				<HeroSvg />
				<div className="d-none d-lg-block d-md-block">
					<Header />
				</div>
				<div className="body">{children}</div>
				<div className="d-block">
					{pathname !== "/" && (
						<div className="">
							<whyCoinsUp />
						</div>
					)}
					<Footer />
				</div>

				{!/^\/product\/[^/]+$/.test(normalizedPathname) && normalizedPathname !== "/leaderboard" && <FooterMenu />}
			</div>
		</React.Fragment>
	);
};

export default Layout;
